import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  HostBinding,
} from '@angular/core';


export class RpControlsOverlayComponent implements OnChanges, OnInit {
    open = false;
    opacity = .66;
    color = 'white';
   overlayClass = 'is-open';

  private bodyEl;

  ngOnChanges({open}: SimpleChanges) {
    if (open) this.toggleBodyClass(open.currentValue);
  }

  ngOnInit() {
    if (document) {
      this.bodyEl = document.querySelector('body');
    }
  }

  toggleBodyClass(isOpen) {
    if (this.bodyEl) {
      if (isOpen) {
        this.bodyEl.classList.add(this.overlayClass);
      } else {
        this.bodyEl.classList.remove(this.overlayClass);
      }
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'rp-controls-overlay',
  styles: [`
    :host.is-shown {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 2;
    }
  `],
  template: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'open': [{ type: Input },{ type: HostBinding, args: ['class.is-shown', ] },],
'opacity': [{ type: Input },{ type: HostBinding, args: ['style.opacity', ] },],
'color': [{ type: Input },{ type: HostBinding, args: ['style.background-color', ] },],
'overlayClass': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
